import { render } from "./participateGPUMining.vue?vue&type=template&id=0a6e24b4&scoped=true"
import script from "./participateGPUMining.vue?vue&type=script&lang=js"
export * from "./participateGPUMining.vue?vue&type=script&lang=js"

import "./participateGPUMining.vue?vue&type=style&index=0&id=0a6e24b4&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6e24b4"]])

export default __exports__